(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const seen = new WeakSet();
  const pending = new Map();
  const selectors = '.clos-wine-card__image-link, .clos-wine-card__details, .clos-portfolio__group-header, .clos-gift-card__image-link, .clos-gift-card__content, .co-pinots__portrait, .co-pinots__identity, .co-pinots__copy, .co-pinots__award, .product-card, .co-gifting > h2, .co-gifting__card, .clos-discovery__wine, .clos-estate-discovery__heading';
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const animation = pending.get(entry.target);
      observer.unobserve(entry.target);
      if (!animation) return;
      if (reduced.matches || entry.target.contains(document.activeElement) || entry.boundingClientRect.top < 0) {
        release(entry.target);
      } else {
        animation.play();
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px 96px 0px' });
  function release(target) {
    observer.unobserve(target);
    pending.get(target)?.cancel();
    pending.delete(target);
  }
  function register(target) {
    if (seen.has(target)) return;
    seen.add(target);
    const rect = target.getBoundingClientRect();
    if (reduced.matches || !rect.height || rect.top <= innerHeight + 96 || target.contains(document.activeElement)) return;
    const animation = target.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 750,
      easing: 'cubic-bezier(.25,.46,.45,.94)',
      fill: 'both'
    });
    animation.pause();
    animation.currentTime = 0;
    pending.set(target, animation);
    animation.finished.then(() => release(target), () => pending.delete(target));
    observer.observe(target);
  }
  function init() {
    document.querySelectorAll('#MainContent > .shopify-section').forEach(section => {
      if (section.querySelector('.hero, [data-testid="product-information"]')) return;
      section.querySelectorAll(selectors).forEach(target => {
        if (!target.parentElement.closest(selectors)) register(target);
      });
    });
  }
  reduced.addEventListener('change', () => {
    if (reduced.matches) Array.from(pending.keys()).forEach(release);
  });
  document.addEventListener('focusin', event => {
    pending.forEach((animation, target) => { if (target.contains(event.target)) release(target); });
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) Array.from(pending.keys()).forEach(release);
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
